import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const getLicenseApiKeys = createAsyncThunk(
  "getLicenseApiKeys",
  async (lastEvalutedkey) => {
    try {
      let res = await axios.get(
        `${process.env.REACT_APP_API_URL}restaurant/license-api-keys`
      );
      if (res.data) {
        return res.data;
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        throw new Error(error.response.data.error);
      }
      if (error.message) {
        throw new Error(error.message);
      }
    }
  }
);

export default getLicenseApiKeys;
